var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMouthRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 9,
    viewBox: "0 0 173 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\xD0\xA0\xD0\xB5\xD0\xB6\xD0\xB8\xD0\xBC_\xD0\xB8\xD0\xB7\xD0\xBE\xD0\xBB\xD1\x8F\xD1\x86\xD0\xB8\xD0\xB8",
    clipPath: "url(#clip0_19_4467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.25977 1.05884C1.25977 1.05884 21.7224 7.94119 41.2526 7.94119C60.7829 7.94119 72.2868 4.11884 86.1595 4.11884C100.032 4.11884 110.856 7.94119 125.737 7.94119C140.617 7.94119 171.74 1.05884 171.74 1.05884",
    stroke: "#FE4B4E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_4467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 173,
    height: 9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouthRed);
export default __webpack_public_path__ + "static/media/mouth_red.6e4b6b99ae6d69a0d259d6ca4e4d1152.svg";
export { ForwardRef as ReactComponent };